export const LOGIN_ROUTE = '/login';
export const THEME_ROUTE = '/theme';

export const DASHBOARD_ROUTE = '/dashboard';
export const HEALTH_INSURANCE_ROUTE = '/health-and-insurance/summary';
export const HEALTH_SUMMARY = '/health/summary';


export const HEALTH_INSURANCE_SUCCESS_ROUTE = '/health-and-insurance/success';
export const HSSC_ROUTE =
  '/health-and-insurance/health-savings-and-spending-channel';
export const PROFILE_ROUTE = '/profile/:tab';
export const VERIFY_DEPENDENT_ROUTE = '/verify-dependent';
export const RESOURCES_ROUTE = '/resources/:tab/*';
export const RETIRE_ROUTE = '/pension/retire-online/:option';
export const SAVINGS_ROUTE = '/savings/savings-enrollment';
export const SAVINGS_SUMMARY = '/savings/summary';
export const TRANSACTION_HISTORY_ROUTE =
  '/health-savings-and-spending-channel/transaction-history';
export const LIFE_EVENTS_ROUTE = '/health-and-insurance/life-events';
export const TOTAL_REWARDS_ROUTE = '/total-rewards';
export const ACCOUNT_ACTIVITY_ROUTE = '/account-activity';
export const ACTIONS_ROUTE = '/profile/actions';
export const RETIREMENT_PLANNING_ROUTE = '/retirement-planning';
export const PENSION_INDEX_ROUTE = '/pension/summary';
export const PENSION_ROUTE = '/pension/estimate/:tab';
export const BENEFICIARIES_ROUTE = 'beneficiaries';
export const HSA_INVESTMENT_ROUTE = 'hsa-investment';
export const TAX_WITHHOLDING_ROUTE = '/tax-withholding';
export const MISSED_BENEFIT_PAYMENTS_ROUTE = '/missed-benefit-payments';
export const DOCUMENT_CENTER_ROUTE = '/documentCenter';
export const BENEFIT_AMOUNTS_ROUTE = '/benefit-amounts';
export const DIRECT_DEPOSIT_ROUTE = '/direct-deposit';
export const PAYMENT_INFO_ROUTE = '/payment-information';
export const PENSION_PROFILE_ROUTE = '/pension/pension-profile';
export const PAY_NOW_ROUTE = '/payment-information/pay-now';
export const PENDING_PAY_ROUTE = '/payment-information/pending-pay';
export const ACCOUNT_STATEMENT_ROUTE = '/account-statement';
export const HW_DASHBOARD_ROUTE = '/health-and-wealth/summary';
export const ACTIVE_RETIREMENT_ELIGIBLE_DASHBOARD_ROUTE =
  '/active-retirement-eligible/summary';
export const INACTIVE_RETIREMENT_ELIGIBLE_DASHBOARD_ROUTE =
  '/inactive-retirement-eligible/summary';
export const NEW_HIRE_DASHBOARD = '/new-hire/summary'
export const DB_INACTIVE_DASHBOARD_ROUTE = '/db-inactive/summary';
export const HW_DB_INACTIVE_DASHBOARD_ROUTE = '/hw-db-inactive/summary';
export const DC_INACTIVE_DASHBOARD_ROUTE = '/dc-inactive/summary';
export const OEHQ_ROUTE = '/open-enrollment-hq';
export const OPEN_ENROLLMENT_ROUTE = '/open-enrollment/summary';
export const OPTIMIZER_ROUTE = '/optimizer';
export const OPTIMIZER_SCORE_ROUTE = '/optimizer/score';
export const COBRA_BENEFITS_ENROLLMENT_ROUTE = '/benefits-enrollment';
export const COBRA_NEW_BENEFITS_ENROLLMENT_ROUTE = '/cobra-benefits-enrollment';
export const BENEFIT_EELECTION_HISTORY_ROUTE = '/benefit-election-history';
export const HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE = '/health-savings-and-spending-inactive-channel';
export const RECENT_TRANSACTIONS_ROUTE = '/recent-transactions'; 
export const RECENT_PAYMENTS_ROUTE = '/recent-payments'; 
